import Sample from 'repos/Sample.js';
export const auditionTrackSamplers = async (track, trackData, subSequence) => {
    track.pattern.volume = trackData.volume;
    if ('samplers' in trackData) {
        for (var soundId in trackData.samplers) {
            let sample = new Sample(soundId);
            await sample.load();
            console.log("USING NEW SOUND TRACK=", track, sample);
            track.useNewSound(sample);
        }
    }
}


export const loadSamplersIntoTrack = async (track, trackData, subSequence) => {
    track.pattern.volume = trackData.volume;
    if ('samplers' in trackData) {
        for (var soundId in trackData.samplers) {
            await track.addSound(
                soundId, // the ipfs hash of the sound
                trackData.samplers[soundId], // the configuration data of the sampler
                undefined,
                false);
        }
    }
    
    if ('envelopes' in trackData) {
        for (let i in trackData.envelopes) {
            track.connectToEnvelope(subSequence.envelopes[trackData.envelopes[i]]);
        }
    }
    if ('envelopeConnections' in trackData) {
        for (let i in trackData.envelopeConnections) {
            let connection = trackData.envelopeConnections[i];
            track.connectToEnvelope(
                subSequence.envelopes[connection.envelope],
                connection.mode);
        }
    }
}
